export const detectOS = () => {
  const ua = navigator.userAgent;
  if (ua.includes('Windows NT 10')) return 'Windows 10/11';
  if (ua.includes('Windows NT 6.3')) return 'Windows 8.1';
  if (ua.includes('Windows NT 6.2')) return 'Windows 8';
  if (ua.includes('Windows NT 6.1')) return 'Windows 7';
  if (ua.includes('Windows')) return 'Windows';
  if (ua.includes('Mac OS X')) {
    const ver = ua.match(/Mac OS X (\d+[._]\d+[._]?\d*)/);
    return ver ? `macOS ${ver[1].replace(/_/g, '.')}` : 'macOS';
  }
  if (ua.includes('Android')) {
    const ver = ua.match(/Android (\d+\.?\d*)/);
    return ver ? `Android ${ver[1]}` : 'Android';
  }
  if (ua.includes('iPhone') || ua.includes('iPad')) {
    const ver = ua.match(/OS (\d+_\d+)/);
    return ver ? `iOS ${ver[1].replace('_', '.')}` : 'iOS';
  }
  if (ua.includes('Linux')) return 'Linux';
  return 'Desconocido';
};

export const detectBrowser = () => {
  const ua = navigator.userAgent;
  if (ua.includes('Edg/')) {
    const v = ua.match(/Edg\/(\d+)/);
    return v ? `Edge ${v[1]}` : 'Edge';
  }
  if (ua.includes('OPR/') || ua.includes('Opera')) {
    const v = ua.match(/OPR\/(\d+)/);
    return v ? `Opera ${v[1]}` : 'Opera';
  }
  if (ua.includes('Chrome/')) {
    const v = ua.match(/Chrome\/(\d+)/);
    return v ? `Chrome ${v[1]}` : 'Chrome';
  }
  if (ua.includes('Firefox/')) {
    const v = ua.match(/Firefox\/(\d+)/);
    return v ? `Firefox ${v[1]}` : 'Firefox';
  }
  if (ua.includes('Safari/') && !ua.includes('Chrome')) {
    const v = ua.match(/Version\/(\d+)/);
    return v ? `Safari ${v[1]}` : 'Safari';
  }
  return 'Desconocido';
};

export const detectDeviceName = () => {
  const ua = navigator.userAgent;
  const androidModel = ua.match(/;\s*([^;)]+)\s*Build/);
  if (androidModel) return androidModel[1].trim();
  if (ua.includes('iPhone')) return 'iPhone';
  if (ua.includes('iPad')) return 'iPad';
  if (ua.includes('Macintosh')) return 'Mac';
  if (ua.includes('Windows')) {
    const winVer = ua.match(/Windows NT (\d+\.\d+)/);
    const arch = ua.includes('Win64') || ua.includes('x64') ? '64-bit' : '32-bit';
    return `PC Windows ${winVer ? winVer[1] : ''} (${arch})`;
  }
  if (ua.includes('Linux') && !ua.includes('Android')) return 'PC Linux';
  return navigator.platform || 'Desconocido';
};

export const detectUserProfile = () => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  if (!ctx) return 'N/A';
  ctx.font = '18px Arial';
  ctx.fillText('ID', 0, 18);
  const data = canvas.toDataURL();
  let hash = 0;
  for (let i = 0; i < data.length; i++) {
    hash = ((hash << 5) - hash) + data.charCodeAt(i);
    hash = hash & hash;
  }
  return 'USR-' + Math.abs(hash).toString(36).toUpperCase().substring(0, 8);
};

export const getCanvasFingerprint = () => {
  try {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx) return 'N/A';
    canvas.width = 200;
    canvas.height = 50;
    ctx.textBaseline = 'top';
    ctx.font = '14px Arial';
    ctx.fillStyle = '#f60';
    ctx.fillRect(125, 1, 62, 20);
    ctx.fillStyle = '#069';
    ctx.fillText('STI Security', 2, 15);
    ctx.fillStyle = 'rgba(102, 204, 0, 0.7)';
    ctx.fillText('Canvas FP', 4, 17);
    const dataURL = canvas.toDataURL();
    let hash = 0;
    for (let i = 0; i < dataURL.length; i++) {
      hash = ((hash << 5) - hash) + dataURL.charCodeAt(i);
      hash = hash & hash;
    }
    return Math.abs(hash).toString(16).substring(0, 8).toUpperCase();
  } catch {
    return 'N/A';
  }
};

export const getWebGLFingerprint = () => {
  try {
    const canvas = document.createElement('canvas');
    const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    if (!gl) {
      return {
        renderer: 'N/A',
        vendor: 'N/A',
        version: 'N/A',
        shadingLang: 'N/A',
        maxTextureSize: 'N/A',
        maxViewport: 'N/A',
        extensions: 0,
        maxAnisotropy: 'N/A',
        maxRenderbuffer: 'N/A',
        aliasedLineWidth: 'N/A',
        aliasedPointSize: 'N/A'
      };
    }
    const debugInfo = (gl as any).getExtension('WEBGL_debug_renderer_info');
    const extensions = (gl as any).getSupportedExtensions();
    const anisoExt = (gl as any).getExtension('EXT_texture_filter_anisotropic');
    return {
      renderer: debugInfo ? (gl as any).getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) || 'N/A' : 'N/A',
      vendor: debugInfo ? (gl as any).getParameter(debugInfo.UNMASKED_VENDOR_WEBGL) || 'N/A' : 'N/A',
      version: (gl as any).getParameter((gl as any).VERSION) || 'N/A',
      shadingLang: (gl as any).getParameter((gl as any).SHADING_LANGUAGE_VERSION) || 'N/A',
      maxTextureSize: String((gl as any).getParameter((gl as any).MAX_TEXTURE_SIZE) || 'N/A'),
      maxViewport: JSON.stringify((gl as any).getParameter((gl as any).MAX_VIEWPORT_DIMS) || []),
      extensions: extensions ? extensions.length : 0,
      maxAnisotropy: anisoExt ? String((gl as any).getParameter(anisoExt.MAX_TEXTURE_MAX_ANISOTROPY_EXT)) : 'N/A',
      maxRenderbuffer: String((gl as any).getParameter((gl as any).MAX_RENDERBUFFER_SIZE) || 'N/A'),
      aliasedLineWidth: JSON.stringify((gl as any).getParameter((gl as any).ALIASED_LINE_WIDTH_RANGE) || []),
      aliasedPointSize: JSON.stringify((gl as any).getParameter((gl as any).ALIASED_POINT_SIZE_RANGE) || [])
    };
  } catch {
    return {
      renderer: 'N/A',
      vendor: 'N/A',
      version: 'N/A',
      shadingLang: 'N/A',
      maxTextureSize: 'N/A',
      maxViewport: 'N/A',
      extensions: 0,
      maxAnisotropy: 'N/A',
      maxRenderbuffer: 'N/A',
      aliasedLineWidth: 'N/A',
      aliasedPointSize: 'N/A'
    };
  }
};

export const getAudioFingerprint = () => {
  try {
    const AC = (window as any).AudioContext || (window as any).webkitAudioContext;
    if (!AC) return 'N/A';
    const ctx = new AC();
    const osc = ctx.createOscillator();
    const analyser = ctx.createAnalyser();
    const gain = ctx.createGain();
    const sp = ctx.createScriptProcessor(4096, 1, 1);
    gain.gain.value = 0;
    osc.connect(analyser);
    analyser.connect(sp);
    sp.connect(gain);
    gain.connect(ctx.destination);
    osc.start(0);
    const hash = analyser.frequencyBinCount.toString(16);
    osc.stop();
    ctx.close();
    return hash.substring(0, 8).toUpperCase();
  } catch {
    return 'N/A';
  }
};

export const getPlugins = () => {
  if (!navigator.plugins || navigator.plugins.length === 0) return 'Ninguno detectado';
  const plugins = Array.from(navigator.plugins).map(p => p.name).slice(0, 5);
  return plugins.join(', ') + (navigator.plugins.length > 5 ? ` (+${navigator.plugins.length - 5} más)` : '');
};

export const getFonts = () => {
  const baseFonts = ['monospace', 'sans-serif', 'serif'];
  const testFonts = [
    'Arial',
    'Verdana',
    'Times New Roman',
    'Courier New',
    'Georgia',
    'Palatino',
    'Garamond',
    'Comic Sans MS',
    'Trebuchet MS',
    'Impact',
    'Lucida Console',
    'Tahoma',
    'Helvetica',
    'Calibri',
    'Cambria',
    'Consolas',
    'Segoe UI'
  ];
  const detected: string[] = [];
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  if (!ctx) return 'N/A';
  const testString = 'mmmmmmmmmmlli';
  const baseWidths: Record<string, number> = {};
  baseFonts.forEach(bf => {
    ctx.font = `72px ${bf}`;
    baseWidths[bf] = ctx.measureText(testString).width;
  });
  testFonts.forEach(font => {
    baseFonts.forEach(bf => {
      ctx.font = `72px ${font}, ${bf}`;
      if (ctx.measureText(testString).width !== baseWidths[bf] && !detected.includes(font)) {
        detected.push(font);
      }
    });
  });
  return detected.length > 0
    ? `${detected.length} fuentes (${detected.slice(0, 5).join(', ')})`
    : 'Estándar';
};

export const getBatteryInfo = async () => {
  try {
    const nav = navigator as any;
    if (!nav.getBattery) return null;
    const battery = await nav.getBattery();
    return {
      level: `${Math.round(battery.level * 100)}%`,
      charging: battery.charging ? 'Cargando' : 'Batería',
      chargingTime: battery.chargingTime === Infinity ? 'N/A' : `${Math.round(battery.chargingTime / 60)} min`,
      dischargingTime: battery.dischargingTime === Infinity ? 'N/A' : `${Math.round(battery.dischargingTime / 60)} min`
    };
  } catch {
    return null;
  }
};

export const getMediaDevices = async () => {
  try {
    if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) return null;
    const devices = await navigator.mediaDevices.enumerateDevices();
    return {
      audio: devices.filter(d => d.kind === 'audioinput').length,
      video: devices.filter(d => d.kind === 'videoinput').length,
      audioOut: devices.filter(d => d.kind === 'audiooutput').length,
      total: devices.length
    };
  } catch {
    return null;
  }
};

export const getPerformanceInfo = () => {
  try {
    const perf = performance as any;
    const nav = perf.getEntriesByType ? perf.getEntriesByType('navigation')[0] as any : null;
    const memory = perf.memory;
    const resources = perf.getEntriesByType ? perf.getEntriesByType('resource') : [];
    const totalTransferred = resources.reduce((sum: number, r: any) => sum + (r.transferSize || 0), 0);
    return {
      pageLoadTime: nav ? `${Math.round(nav.loadEventEnd - nav.startTime)}ms` : 'N/A',
      domReady: nav ? `${Math.round(nav.domContentLoadedEventEnd - nav.startTime)}ms` : 'N/A',
      dnsLookup: nav ? `${Math.round(nav.domainLookupEnd - nav.domainLookupStart)}ms` : 'N/A',
      tcpConnect: nav ? `${Math.round(nav.connectEnd - nav.connectStart)}ms` : 'N/A',
      ttfb: nav ? `${Math.round(nav.responseStart - nav.requestStart)}ms` : 'N/A',
      domInteractive: nav ? `${Math.round(nav.domInteractive - nav.startTime)}ms` : 'N/A',
      jsHeapSize: memory
        ? `${Math.round(memory.usedJSHeapSize / 1048576)}MB / ${Math.round(memory.jsHeapSizeLimit / 1048576)}MB`
        : 'N/A',
      totalHeap: memory ? `${Math.round(memory.totalJSHeapSize / 1048576)}MB` : 'N/A',
      resourceCount: resources ? String(resources.length) : 'N/A',
      navigationType: nav ? nav.type : 'N/A',
      redirectCount: nav ? String(nav.redirectCount || 0) : 'N/A',
      transferSize: `${(totalTransferred / 1024).toFixed(1)} KB`,
      sslTime:
        nav && nav.secureConnectionStart > 0
          ? `${Math.round(nav.connectEnd - nav.secureConnectionStart)}ms`
          : 'N/A',
      firstPaint: (() => {
        try {
          const fp = perf.getEntriesByType('paint').find((e: any) => e.name === 'first-paint');
          return fp ? `${Math.round(fp.startTime)}ms` : 'N/A';
        } catch {
          return 'N/A';
        }
      })(),
      fcp: (() => {
        try {
          const fcp = perf.getEntriesByType('paint').find((e: any) => e.name === 'first-contentful-paint');
          return fcp ? `${Math.round(fcp.startTime)}ms` : 'N/A';
        } catch {
          return 'N/A';
        }
      })()
    };
  } catch {
    return null;
  }
};

export const getSecurityInfo = () => {
  const info: Record<string, string> = {};
  info.protocol = window.location.protocol === 'https:' ? 'HTTPS (Seguro)' : 'HTTP (No seguro)';
  info.secureContext = window.isSecureContext ? 'Sí' : 'No';
  info.crossOriginIsolated = (window as any).crossOriginIsolated ? 'Sí' : 'No';
  info.cookieEnabled = navigator.cookieEnabled ? 'Habilitadas' : 'Deshabilitadas';
  info.doNotTrack =
    navigator.doNotTrack === '1'
      ? 'Activado'
      : navigator.doNotTrack === '0'
      ? 'Desactivado'
      : 'No configurado';
  const permPolicies = [
    'camera',
    'microphone',
    'geolocation',
    'fullscreen',
    'payment',
    'autoplay',
    'accelerometer',
    'gyroscope',
    'magnetometer'
  ];
  const detected: string[] = [];
  permPolicies.forEach(p => {
    try {
      if ((document as any).featurePolicy && (document as any).featurePolicy.allowsFeature(p))
        detected.push(p);
    } catch (error) {
      // Silently ignore feature policy check errors
      console.debug(`Feature policy check failed for ${p}:`, error);
    }
  });
  info.permissionsDetected = detected.length > 0 ? detected.join(', ') : 'No detectadas';
  info.referrerPolicy = document.referrer ? 'Referrer presente' : 'Sin referrer';
  info.pdfViewer =
    (navigator as any).pdfViewerEnabled !== undefined
      ? (navigator as any).pdfViewerEnabled
        ? 'Integrado'
        : 'No'
      : 'N/A';
  info.csp = (() => {
    const meta = document.querySelector('meta[http-equiv="Content-Security-Policy"]');
    return meta ? 'Configurado' : 'No detectado';
  })();
  info.frameAncestors = window.self === window.top ? 'No embebido' : 'Embebido en iframe';
  return info;
};

export const getStorageEstimate = async () => {
  try {
    if (navigator.storage && navigator.storage.estimate) {
      const est = await navigator.storage.estimate();
      return {
        used: `${est.usage ? (est.usage / 1048576).toFixed(2) : '0'} MB`,
        quota: `${est.quota ? (est.quota / 1048576).toFixed(0) : 'N/A'} MB`,
        percent:
          est.usage && est.quota ? `${((est.usage / est.quota) * 100).toFixed(2)}%` : 'N/A'
      };
    }
    return null;
  } catch {
    return null;
  }
};

export const getAccessibilityInfo = () => ({
  prefersReducedMotion: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'Sí' : 'No',
  prefersColorScheme: window.matchMedia('(prefers-color-scheme: dark)').matches ? 'Oscuro' : 'Claro',
  prefersContrast: window.matchMedia('(prefers-contrast: high)').matches ? 'Alto' : 'Normal',
  forcedColors: window.matchMedia('(forced-colors: active)').matches ? 'Activo' : 'No',
  invertedColors: window.matchMedia('(inverted-colors: inverted)').matches ? 'Sí' : 'No',
  prefersTransparency: window
    .matchMedia('(prefers-reduced-transparency: reduce)')
    .matches ? 'Reducida' : 'Normal'
});

export const getMediaCapabilities = () => {
  const video = document.createElement('video');
  const audio = document.createElement('audio');
  return {
    h264: video.canPlayType('video/mp4; codecs="avc1.42E01E"') ? 'Soportado' : 'No',
    h265: video.canPlayType('video/mp4; codecs="hev1.1.6.L93.B0"') ? 'Soportado' : 'No',
    vp8: video.canPlayType('video/webm; codecs="vp8"') ? 'Soportado' : 'No',
    vp9: video.canPlayType('video/webm; codecs="vp9"') ? 'Soportado' : 'No',
    av1: video.canPlayType('video/mp4; codecs="av01.0.01M.08"') ? 'Soportado' : 'No',
    webm: video.canPlayType('video/webm') ? 'Soportado' : 'No',
    mp3: audio.canPlayType('audio/mpeg') ? 'Soportado' : 'No',
    aac: audio.canPlayType('audio/aac') ? 'Soportado' : 'No',
    ogg: audio.canPlayType('audio/ogg; codecs="vorbis"') ? 'Soportado' : 'No',
    opus: audio.canPlayType('audio/ogg; codecs="opus"') ? 'Soportado' : 'No',
    flac: audio.canPlayType('audio/flac') ? 'Soportado' : 'No',
    wav: audio.canPlayType('audio/wav') ? 'Soportado' : 'No',
    webp: (() => {
      const c = document.createElement('canvas');
      c.width = 1;
      c.height = 1;
      return c.toDataURL('image/webp').indexOf('data:image/webp') === 0 ? 'Soportado' : 'No';
    })(),
    avif: 'N/A'
  };
};

export const getAdvancedAPIs = () => {
  const check = (obj: any, prop: string) => (prop in obj ? 'Soportado' : 'No');
  return {
    speechRecognition:
      'SpeechRecognition' in window || 'webkitSpeechRecognition' in window ? 'Soportado' : 'No',
    speechSynthesis: check(window, 'speechSynthesis'),
    gamepad: check(navigator, 'getGamepads'),
    vibration: check(navigator, 'vibrate'),
    wakeLock: check(navigator, 'wakeLock'),
    share: check(navigator, 'share'),
    clipboard: check(navigator, 'clipboard'),
    credentials: check(navigator, 'credentials'),
    presentation: check(navigator, 'presentation'),
    serial: check(navigator, 'serial'),
    hid: check(navigator, 'hid'),
    nfc: 'NDEFReader' in window ? 'Soportado' : 'No',
    xr: check(navigator, 'xr'),
    midi: check(navigator, 'requestMIDIAccess'),
    scheduling: check(navigator, 'scheduling'),
    bluetooth: check(navigator, 'bluetooth'),
    usb: check(navigator, 'usb'),
    mediaSession: check(navigator, 'mediaSession'),
    locks: check(navigator, 'locks'),
    storageManager: check(navigator, 'storage'),
    permissions: check(navigator, 'permissions'),
    contactPicker: check(navigator, 'contacts'),
    eyeDropper: 'EyeDropper' in window ? 'Soportado' : 'No',
    fileSystem: 'showOpenFilePicker' in window ? 'Soportado' : 'No',
    barcode: 'BarcodeDetector' in window ? 'Soportado' : 'No',
    faceDetection: 'FaceDetector' in window ? 'Soportado' : 'No',
    textDetection: 'TextDetector' in window ? 'Soportado' : 'No',
    idleDetection: 'IdleDetector' in window ? 'Soportado' : 'No',
    screenCapture: check(navigator.mediaDevices || {}, 'getDisplayMedia'),
    pictureInPicture: 'pictureInPictureEnabled' in document ? 'Soportado' : 'No',
    webTransport: 'WebTransport' in window ? 'Soportado' : 'No',
    webCodecs: 'VideoEncoder' in window ? 'Soportado' : 'No'
  };
};

export const getNetworkAdvanced = () => {
  const conn =
    (navigator as any).connection ||
    (navigator as any).mozConnection ||
    (navigator as any).webkitConnection;
  if (!conn) return null;
  return {
    effectiveType: conn.effectiveType ? conn.effectiveType.toUpperCase() : 'N/A',
    downlink: conn.downlink ? `${conn.downlink} Mbps` : 'N/A',
    rtt: conn.rtt ? `${conn.rtt} ms` : 'N/A',
    saveData:
      conn.saveData !== undefined ? (conn.saveData ? 'Activado' : 'Desactivado') : 'N/A',
    type: conn.type || 'N/A',
    downlinkMax: conn.downlinkMax ? `${conn.downlinkMax} Mbps` : 'N/A'
  };
};

export const getVulnerabilityAssessment = () => {
  const vulns: Array<{ name: string; status: string; severity: string; detail: string }> = [];

  // Check HTTPS
  vulns.push({
    name: 'Protocolo HTTPS',
    status: window.location.protocol === 'https:' ? 'SEGURO' : 'VULNERABLE',
    severity: window.location.protocol === 'https:' ? 'low' : 'critical',
    detail:
      window.location.protocol === 'https:'
        ? 'Conexión cifrada activa'
        : 'Conexión sin cifrar - datos expuestos'
  });

  // Check Secure Context
  vulns.push({
    name: 'Contexto Seguro',
    status: window.isSecureContext ? 'SEGURO' : 'RIESGO',
    severity: window.isSecureContext ? 'low' : 'high',
    detail: window.isSecureContext ? 'APIs seguras disponibles' : 'APIs restringidas por contexto inseguro'
  });

  // Check iframe embedding
  vulns.push({
    name: 'Clickjacking (iframe)',
    status: window.self === window.top ? 'PROTEGIDO' : 'EXPUESTO',
    severity: window.self === window.top ? 'low' : 'high',
    detail: window.self === window.top ? 'No embebido en iframe' : 'Página embebida - posible clickjacking'
  });

  // Check CSP
  const cspMeta = document.querySelector('meta[http-equiv="Content-Security-Policy"]');
  vulns.push({
    name: 'Content Security Policy',
    status: cspMeta ? 'CONFIGURADO' : 'AUSENTE',
    severity: cspMeta ? 'low' : 'medium',
    detail: cspMeta ? 'CSP detectado en meta tags' : 'Sin CSP - riesgo de XSS'
  });

  // Check X-Frame-Options
  vulns.push({
    name: 'X-Frame-Options',
    status: window.self === window.top ? 'PROTEGIDO' : 'RIESGO',
    severity: window.self === window.top ? 'low' : 'medium',
    detail: window.self === window.top ? 'No embebido - protección activa' : 'Embebido - verificar headers X-Frame-Options'
  });

  // Check HSTS
  vulns.push({
    name: 'HSTS (Strict-Transport-Security)',
    status: window.location.protocol === 'https:' ? 'PROBABLE' : 'AUSENTE',
    severity: window.location.protocol === 'https:' ? 'low' : 'high',
    detail: window.location.protocol === 'https:' ? 'HTTPS activo - HSTS probable' : 'HTTP - HSTS no aplicable'
  });

  // Check Mixed Content
  vulns.push({
    name: 'Mixed Content',
    status: window.location.protocol === 'https:' ? 'PROTEGIDO' : 'VULNERABLE',
    severity: window.location.protocol === 'https:' ? 'low' : 'high',
    detail: window.location.protocol === 'https:' ? 'Contenido mixto bloqueado' : 'HTTP permite contenido mixto inseguro'
  });

  // Check cookies
  vulns.push({
    name: 'Cookies',
    status: navigator.cookieEnabled ? 'HABILITADAS' : 'BLOQUEADAS',
    severity: 'info',
    detail: navigator.cookieEnabled ? 'Cookies activas - posible tracking' : 'Cookies bloqueadas'
  });

  // Check Secure Cookies
  vulns.push({
    name: 'Secure Cookies',
    status: window.location.protocol === 'https:' ? 'POSIBLE' : 'NO DISPONIBLE',
    severity: window.location.protocol === 'https:' ? 'low' : 'medium',
    detail: window.location.protocol === 'https:' ? 'HTTPS permite cookies seguras' : 'HTTP - cookies sin flag Secure'
  });

  // Check SameSite Cookies
  vulns.push({
    name: 'SameSite Cookies',
    status: 'VERIFICAR',
    severity: 'info',
    detail: 'Verificar atributo SameSite en cookies para prevenir CSRF'
  });

  // Check Do Not Track
  vulns.push({
    name: 'Do Not Track',
    status: navigator.doNotTrack === '1' ? 'ACTIVADO' : 'DESACTIVADO',
    severity: navigator.doNotTrack === '1' ? 'low' : 'medium',
    detail:
      navigator.doNotTrack === '1' ? 'Solicitud DNT enviada' : 'Sin protección DNT - tracking posible'
  });

  // Check WebRTC leak
  vulns.push({
    name: 'WebRTC IP Leak',
    status: (window as any).RTCPeerConnection ? 'EXPUESTO' : 'PROTEGIDO',
    severity: (window as any).RTCPeerConnection ? 'high' : 'low',
    detail: (window as any).RTCPeerConnection
      ? 'WebRTC activo - IP local puede filtrarse'
      : 'WebRTC no disponible'
  });

  // Check Canvas fingerprinting
  vulns.push({
    name: 'Canvas Fingerprinting',
    status: 'EXPUESTO',
    severity: 'medium',
    detail: 'Canvas API disponible - huella digital posible'
  });

  // Check WebGL fingerprinting
  const glCanvas = document.createElement('canvas');
  const gl = glCanvas.getContext('webgl');
  vulns.push({
    name: 'WebGL Fingerprinting',
    status: gl ? 'EXPUESTO' : 'PROTEGIDO',
    severity: gl ? 'medium' : 'low',
    detail: gl ? 'WebGL activo - GPU identificable' : 'WebGL no disponible'
  });

  // Check Audio fingerprinting
  const hasAudio = (window as any).AudioContext || (window as any).webkitAudioContext;
  vulns.push({
    name: 'Audio Fingerprinting',
    status: hasAudio ? 'EXPUESTO' : 'PROTEGIDO',
    severity: hasAudio ? 'medium' : 'low',
    detail: hasAudio ? 'AudioContext disponible - huella de audio posible' : 'AudioContext no disponible'
  });

  // Check Font Fingerprinting
  vulns.push({
    name: 'Font Fingerprinting',
    status: 'EXPUESTO',
    severity: 'medium',
    detail: 'Fuentes del sistema detectables - identificación posible'
  });

  // Check Screen Fingerprinting
  vulns.push({
    name: 'Screen Fingerprinting',
    status: 'EXPUESTO',
    severity: 'low',
    detail: `Resolución ${window.screen.width}x${window.screen.height} detectable`
  });

  // Check Timezone Fingerprinting
  vulns.push({
    name: 'Timezone Fingerprinting',
    status: 'EXPUESTO',
    severity: 'low',
    detail: `Zona horaria ${Intl.DateTimeFormat().resolvedOptions().timeZone} detectable`
  });

  // Check Geolocation
  vulns.push({
    name: 'Geolocalización',
    status: 'geolocation' in navigator ? 'DISPONIBLE' : 'NO DISPONIBLE',
    severity: 'geolocation' in navigator ? 'medium' : 'low',
    detail: 'geolocation' in navigator
      ? 'API de ubicación accesible (requiere permiso)'
      : 'Geolocalización no soportada'
  });

  // Check Camera/Mic
  vulns.push({
    name: 'Cámara/Micrófono',
    status: navigator.mediaDevices ? 'ACCESIBLE' : 'NO DISPONIBLE',
    severity: navigator.mediaDevices ? 'medium' : 'low',
    detail: navigator.mediaDevices
      ? 'Dispositivos multimedia detectables (requiere permiso)'
      : 'MediaDevices no disponible'
  });

  // Check Notifications
  vulns.push({
    name: 'Notificaciones Push',
    status: 'Notification' in window ? 'DISPONIBLE' : 'NO DISPONIBLE',
    severity: 'Notification' in window ? 'low' : 'low',
    detail: 'Notification' in window ? 'API de notificaciones accesible (requiere permiso)' : 'Notificaciones no soportadas'
  });

  // Check Clipboard
  vulns.push({
    name: 'Clipboard API',
    status: 'clipboard' in navigator ? 'ACCESIBLE' : 'BLOQUEADO',
    severity: 'clipboard' in navigator ? 'medium' : 'low',
    detail: 'clipboard' in navigator ? 'Acceso al portapapeles posible' : 'Clipboard API no disponible'
  });

  // Check Service Worker
  vulns.push({
    name: 'Service Workers',
    status: 'serviceWorker' in navigator ? 'SOPORTADO' : 'NO DISPONIBLE',
    severity: 'info',
    detail: 'serviceWorker' in navigator
      ? 'Puede interceptar requests de red'
      : 'Service Workers no soportados'
  });

  // Check Local Storage
  vulns.push({
    name: 'Almacenamiento Local',
    status: typeof Storage !== 'undefined' ? 'DISPONIBLE' : 'BLOQUEADO',
    severity: 'info',
    detail:
      typeof Storage !== 'undefined'
        ? 'localStorage/sessionStorage accesibles - datos persistentes'
        : 'Storage bloqueado'
  });

  // Check IndexedDB
  vulns.push({
    name: 'IndexedDB',
    status: typeof indexedDB !== 'undefined' ? 'DISPONIBLE' : 'BLOQUEADO',
    severity: 'info',
    detail: typeof indexedDB !== 'undefined' ? 'Base de datos local accesible' : 'IndexedDB no disponible'
  });

  // Check Cross-Origin Isolation
  vulns.push({
    name: 'Cross-Origin Isolation',
    status: (window as any).crossOriginIsolated ? 'AISLADO' : 'NO AISLADO',
    severity: (window as any).crossOriginIsolated ? 'low' : 'medium',
    detail: (window as any).crossOriginIsolated
      ? 'Aislamiento cross-origin activo'
      : 'Sin aislamiento - SharedArrayBuffer restringido'
  });

  // Check CORS
  vulns.push({
    name: 'CORS (Cross-Origin)',
    status: 'VERIFICAR',
    severity: 'info',
    detail: 'Verificar configuración CORS en servidor para prevenir acceso no autorizado'
  });

  // Check Referrer
  vulns.push({
    name: 'Referrer Leakage',
    status: document.referrer ? 'FILTRADO' : 'LIMPIO',
    severity: document.referrer ? 'low' : 'low',
    detail: document.referrer
      ? `Origen filtrado: ${document.referrer.substring(0, 50)}`
      : 'Sin referrer - origen oculto'
  });

  // Check Referrer Policy
  const referrerPolicy = document.querySelector('meta[name="referrer"]');
  vulns.push({
    name: 'Referrer Policy',
    status: referrerPolicy ? 'CONFIGURADO' : 'POR DEFECTO',
    severity: referrerPolicy ? 'low' : 'medium',
    detail: referrerPolicy ? 'Política de referrer configurada' : 'Sin política explícita - puede filtrar información'
  });

  // Check Screen capture
  vulns.push({
    name: 'Captura de Pantalla',
    status:
      navigator.mediaDevices && 'getDisplayMedia' in navigator.mediaDevices
        ? 'DISPONIBLE'
        : 'NO DISPONIBLE',
    severity:
      navigator.mediaDevices && 'getDisplayMedia' in navigator.mediaDevices
        ? 'medium'
        : 'low',
    detail:
      navigator.mediaDevices && 'getDisplayMedia' in navigator.mediaDevices
        ? 'Screen Capture API disponible'
        : 'No soportado'
  });

  // Check Bluetooth
  vulns.push({
    name: 'Web Bluetooth',
    status: 'bluetooth' in navigator ? 'DISPONIBLE' : 'NO DISPONIBLE',
    severity: 'bluetooth' in navigator ? 'medium' : 'low',
    detail: 'bluetooth' in navigator ? 'API Bluetooth accesible (requiere permiso)' : 'Bluetooth no soportado'
  });

  // Check USB
  vulns.push({
    name: 'WebUSB',
    status: 'usb' in navigator ? 'DISPONIBLE' : 'NO DISPONIBLE',
    severity: 'usb' in navigator ? 'medium' : 'low',
    detail: 'usb' in navigator ? 'API USB accesible (requiere permiso)' : 'USB no soportado'
  });

  // Check Serial
  vulns.push({
    name: 'Web Serial',
    status: 'serial' in navigator ? 'DISPONIBLE' : 'NO DISPONIBLE',
    severity: 'serial' in navigator ? 'medium' : 'low',
    detail: 'serial' in navigator ? 'API Serial accesible (requiere permiso)' : 'Serial no soportado'
  });

  // Check HID
  vulns.push({
    name: 'WebHID',
    status: 'hid' in navigator ? 'DISPONIBLE' : 'NO DISPONIBLE',
    severity: 'hid' in navigator ? 'medium' : 'low',
    detail: 'hid' in navigator ? 'API HID accesible (requiere permiso)' : 'HID no soportado'
  });

  // Check MIDI
  vulns.push({
    name: 'Web MIDI',
    status: 'requestMIDIAccess' in navigator ? 'DISPONIBLE' : 'NO DISPONIBLE',
    severity: 'requestMIDIAccess' in navigator ? 'low' : 'low',
    detail: 'requestMIDIAccess' in navigator ? 'API MIDI accesible (requiere permiso)' : 'MIDI no soportado'
  });

  // Check Battery Status
  vulns.push({
    name: 'Battery Status API',
    status: 'getBattery' in navigator ? 'DISPONIBLE' : 'NO DISPONIBLE',
    severity: 'getBattery' in navigator ? 'low' : 'low',
    detail: 'getBattery' in navigator ? 'Estado de batería detectable' : 'Battery API no disponible'
  });

  // Check Network Information
  const conn = (navigator as any).connection || (navigator as any).mozConnection || (navigator as any).webkitConnection;
  vulns.push({
    name: 'Network Information API',
    status: conn ? 'EXPUESTO' : 'NO DISPONIBLE',
    severity: conn ? 'low' : 'low',
    detail: conn ? 'Información de red detectable' : 'Network API no disponible'
  });

  // Check Device Memory
  vulns.push({
    name: 'Device Memory',
    status: (navigator as any).deviceMemory ? 'EXPUESTO' : 'NO DISPONIBLE',
    severity: (navigator as any).deviceMemory ? 'low' : 'low',
    detail: (navigator as any).deviceMemory ? `${(navigator as any).deviceMemory} GB RAM detectable` : 'Device Memory no disponible'
  });

  // Check Hardware Concurrency
  vulns.push({
    name: 'Hardware Concurrency',
    status: navigator.hardwareConcurrency ? 'EXPUESTO' : 'NO DISPONIBLE',
    severity: navigator.hardwareConcurrency ? 'low' : 'low',
    detail: navigator.hardwareConcurrency ? `${navigator.hardwareConcurrency} núcleos CPU detectables` : 'Hardware Concurrency no disponible'
  });

  // Check Platform
  vulns.push({
    name: 'Platform Detection',
    status: 'EXPUESTO',
    severity: 'low',
    detail: `Plataforma ${navigator.platform} detectable`
  });

  // Check User Agent
  vulns.push({
    name: 'User Agent',
    status: 'EXPUESTO',
    severity: 'low',
    detail: 'User Agent completo detectable - identificación de navegador y OS'
  });

  // Check Languages
  vulns.push({
    name: 'Language Detection',
    status: 'EXPUESTO',
    severity: 'low',
    detail: `Idiomas ${navigator.languages?.join(', ') || navigator.language} detectables`
  });

  // Check Plugins
  vulns.push({
    name: 'Plugin Enumeration',
    status: navigator.plugins && navigator.plugins.length > 0 ? 'EXPUESTO' : 'PROTEGIDO',
    severity: navigator.plugins && navigator.plugins.length > 0 ? 'low' : 'low',
    detail: navigator.plugins && navigator.plugins.length > 0 ? `${navigator.plugins.length} plugins detectables` : 'Plugins no enumerables'
  });

  // Check WebAssembly
  vulns.push({
    name: 'WebAssembly',
    status: typeof WebAssembly !== 'undefined' ? 'DISPONIBLE' : 'NO DISPONIBLE',
    severity: 'info',
    detail: typeof WebAssembly !== 'undefined' ? 'WASM soportado - código nativo ejecutable' : 'WASM no soportado'
  });

  // Check SharedArrayBuffer
  vulns.push({
    name: 'SharedArrayBuffer',
    status: typeof SharedArrayBuffer !== 'undefined' ? 'DISPONIBLE' : 'BLOQUEADO',
    severity: typeof SharedArrayBuffer !== 'undefined' ? 'medium' : 'low',
    detail: typeof SharedArrayBuffer !== 'undefined' ? 'Memoria compartida disponible - requiere aislamiento' : 'SharedArrayBuffer bloqueado'
  });

  // Check Spectre/Meltdown Mitigations
  vulns.push({
    name: 'Spectre/Meltdown',
    status: (window as any).crossOriginIsolated ? 'MITIGADO' : 'RIESGO',
    severity: (window as any).crossOriginIsolated ? 'low' : 'medium',
    detail: (window as any).crossOriginIsolated ? 'Cross-Origin Isolation activo' : 'Sin aislamiento - vulnerable a timing attacks'
  });

  // Check Permissions API
  vulns.push({
    name: 'Permissions API',
    status: 'permissions' in navigator ? 'DISPONIBLE' : 'NO DISPONIBLE',
    severity: 'info',
    detail: 'permissions' in navigator ? 'Estado de permisos consultable' : 'Permissions API no disponible'
  });

  // Check Credential Management
  vulns.push({
    name: 'Credential Management',
    status: 'credentials' in navigator ? 'DISPONIBLE' : 'NO DISPONIBLE',
    severity: 'info',
    detail: 'credentials' in navigator ? 'API de credenciales disponible' : 'Credential Management no soportado'
  });

  // Check Payment Request
  vulns.push({
    name: 'Payment Request API',
    status: 'PaymentRequest' in window ? 'DISPONIBLE' : 'NO DISPONIBLE',
    severity: 'info',
    detail: 'PaymentRequest' in window ? 'API de pagos disponible' : 'Payment Request no soportado'
  });

  // Check Web Authentication
  vulns.push({
    name: 'Web Authentication (WebAuthn)',
    status: 'credentials' in navigator && 'PublicKeyCredential' in window ? 'DISPONIBLE' : 'NO DISPONIBLE',
    severity: 'info',
    detail: 'credentials' in navigator && 'PublicKeyCredential' in window ? 'WebAuthn soportado - autenticación biométrica posible' : 'WebAuthn no disponible'
  });

  return vulns;
};

export const getBrowserInfo = async () => {
  const info: Record<string, string> = {};
  const now = new Date();
  info.currentDateTime = now.toLocaleString('es-AR', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  });
  info.currentDate = now.toLocaleDateString('es-AR');
  info.currentTime = now.toLocaleTimeString('es-AR', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  });
  try {
    info.hostname = window.location.hostname || 'N/A';
  } catch {
    info.hostname = 'N/A';
  }
  try {
    const pc = new RTCPeerConnection({ iceServers: [] });
    pc.createDataChannel('');
    const offer = await pc.createOffer();
    await pc.setLocalDescription(offer);
    const sdp = offer.sdp || '';
    const hostMatch = sdp.match(/a=candidate.*?(\d+\.\d+\.\d+\.\d+)/);
    if (hostMatch) info.localIP = hostMatch[1];
    pc.close();
  } catch {
    info.localIP = 'Bloqueado por navegador';
  }

  info.deviceName = detectDeviceName();
  info.userProfile = detectUserProfile();
  info.os = detectOS();
  info.browser = detectBrowser();
  info.userAgent = navigator.userAgent;
  info.screen = `${window.screen.width}x${window.screen.height}`;
  info.availScreen = `${window.screen.availWidth}x${window.screen.availHeight}`;
  info.viewport = `${window.innerWidth}x${window.innerHeight}`;
  info.outerWindow = `${window.outerWidth}x${window.outerHeight}`;
  info.language = navigator.language || 'N/A';
  info.languages = (navigator.languages || []).join(', ') || 'N/A';
  info.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'N/A';
  info.timezoneOffset = `UTC${-new Date().getTimezoneOffset() / 60}`;
  info.platform = navigator.platform || 'N/A';
  info.cores = navigator.hardwareConcurrency
    ? `${navigator.hardwareConcurrency} núcleos`
    : 'N/A';
  info.memory = (navigator as any).deviceMemory
    ? `${(navigator as any).deviceMemory} GB`
    : 'N/A';
  info.touch = navigator.maxTouchPoints > 0 ? `Sí (${navigator.maxTouchPoints} puntos)` : 'No';
  info.cookies = navigator.cookieEnabled ? 'Habilitadas' : 'Deshabilitadas';
  info.online = navigator.onLine ? 'En línea' : 'Sin conexión';
  info.doNotTrack = navigator.doNotTrack || 'No configurado';
  info.colorDepth = `${window.screen.colorDepth} bits`;
  info.pixelDepth = `${window.screen.pixelDepth} bits`;
  info.dpr = `${window.devicePixelRatio || 1}x`;
  info.orientation = window.screen.orientation ? window.screen.orientation.type : 'N/A';
  info.historyLength = String(window.history.length);
  info.documentTitle = document.title || 'N/A';
  info.documentCharset = document.characterSet || 'N/A';
  info.documentMode = (document as any).documentMode
    ? String((document as any).documentMode)
    : 'Estándar';
  info.pageURL = window.location.href;
  info.pageProtocol = window.location.protocol;
  info.pageHost = window.location.host;
  info.pagePath = window.location.pathname;

  const conn = (navigator as any).connection || (navigator as any).mozConnection || (navigator as any).webkitConnection;
  if (conn) {
    info.connection = conn.effectiveType ? conn.effectiveType.toUpperCase() : 'N/A';
    if (conn.downlink) info.downlink = `${conn.downlink} Mbps`;
    if (conn.rtt) info.rtt = `${conn.rtt} ms`;
    if (conn.saveData !== undefined) info.saveData = conn.saveData ? 'Activado' : 'Desactivado';
    if (conn.type) info.connectionType = conn.type;
    if (conn.downlinkMax) info.downlinkMax = `${conn.downlinkMax} Mbps`;
  }

  info.canvasFingerprint = getCanvasFingerprint();
  info.audioFingerprint = getAudioFingerprint();
  const webgl = getWebGLFingerprint();
  info.webglVendor = webgl.vendor;
  info.webglRenderer = webgl.renderer;
  info.webglVersion = webgl.version;
  info.webglShadingLang = webgl.shadingLang;
  info.webglMaxTexture = webgl.maxTextureSize;
  info.webglMaxViewport = webgl.maxViewport;
  info.webglExtensions = String(webgl.extensions);
  info.webglMaxAnisotropy = webgl.maxAnisotropy;
  info.webglMaxRenderbuffer = webgl.maxRenderbuffer;
  info.webglAliasedLine = webgl.aliasedLineWidth;
  info.webglAliasedPoint = webgl.aliasedPointSize;
  info.plugins = getPlugins();
  info.fonts = getFonts();

  info.localStorage = typeof Storage !== 'undefined' ? 'Disponible' : 'No disponible';
  info.sessionStorage = typeof sessionStorage !== 'undefined' ? 'Disponible' : 'No disponible';
  info.indexedDB = typeof indexedDB !== 'undefined' ? 'Disponible' : 'No disponible';
  info.webWorkers = typeof Worker !== 'undefined' ? 'Soportado' : 'No soportado';
  info.serviceWorker = 'serviceWorker' in navigator ? 'Soportado' : 'No soportado';
  info.webGL = document.createElement('canvas').getContext('webgl') ? 'Soportado' : 'No soportado';
  info.webGL2 = document.createElement('canvas').getContext('webgl2') ? 'Soportado' : 'No soportado';
  info.webRTC = (window as any).RTCPeerConnection ? 'Soportado' : 'No soportado';
  info.webAssembly = typeof WebAssembly !== 'undefined' ? 'Soportado' : 'No soportado';
  info.sharedWorker = typeof SharedWorker !== 'undefined' ? 'Soportado' : 'No soportado';
  info.webSocket = typeof WebSocket !== 'undefined' ? 'Soportado' : 'No soportado';
  info.webAnimation = typeof Element.prototype.animate !== 'undefined' ? 'Soportado' : 'No soportado';
  info.intersectionObserver = typeof IntersectionObserver !== 'undefined' ? 'Soportado' : 'No soportado';
  info.resizeObserver = typeof ResizeObserver !== 'undefined' ? 'Soportado' : 'No soportado';
  info.mutationObserver = typeof MutationObserver !== 'undefined' ? 'Soportado' : 'No soportado';
  info.broadcastChannel = typeof BroadcastChannel !== 'undefined' ? 'Soportado' : 'No soportado';
  info.geolocation = 'geolocation' in navigator ? 'Disponible' : 'No disponible';
  info.notifications = 'Notification' in window ? 'Disponible' : 'No disponible';
  info.bluetooth = 'bluetooth' in navigator ? 'Disponible' : 'No disponible';
  info.usb = 'usb' in navigator ? 'Disponible' : 'No disponible';

  const security = getSecurityInfo();
  Object.entries(security).forEach(([k, v]) => {
    info[`sec_${k}`] = v;
  });

  const perf = getPerformanceInfo();
  if (perf) {
    Object.entries(perf).forEach(([k, v]) => {
      info[`perf_${k}`] = v;
    });
  }

  const storage = await getStorageEstimate();
  if (storage) {
    info.storageUsed = storage.used;
    info.storageQuota = storage.quota;
    info.storagePercent = storage.percent;
  }

  const a11y = getAccessibilityInfo();
  Object.entries(a11y).forEach(([k, v]) => {
    info[`a11y_${k}`] = v;
  });

  const media = getMediaCapabilities();
  Object.entries(media).forEach(([k, v]) => {
    info[`codec_${k}`] = v;
  });

  const apis = getAdvancedAPIs();
  Object.entries(apis).forEach(([k, v]) => {
    info[`api_${k}`] = v;
  });

  const battery = await getBatteryInfo();
  if (battery) {
    info.batteryLevel = battery.level;
    info.batteryStatus = battery.charging;
    info.batteryChargeTime = battery.chargingTime;
    info.batteryDischargeTime = battery.dischargingTime;
  }

  const mediaDevs = await getMediaDevices();
  if (mediaDevs) {
    info.microphones = `${mediaDevs.audio} detectados`;
    info.cameras = `${mediaDevs.video} detectadas`;
    info.speakers = `${mediaDevs.audioOut} detectados`;
    info.totalDevices = `${mediaDevs.total} dispositivos`;
  }

  info.localTime = new Date().toLocaleString('es-AR');
  info.timestamp = Date.now().toString();
  return info;
};

export const infoSections = [
  {
    title: '📈 COMPORTAMIENTO EN EL SITIO',
    icon: 'ri-bar-chart-line',
    color: 'text-emerald-400',
    items: [
      { icon: 'ri-fingerprint-line', color: 'text-purple-400', label: 'ID Sesión', key: 'sessionId' },
      { icon: 'ri-time-line', color: 'text-blue-400', label: 'Inicio Sesión', key: 'sessionStart' },
      { icon: 'ri-timer-line', color: 'text-green-400', label: 'Tiempo Total', key: 'totalTimeOnSite' },
      { icon: 'ri-cursor-line', color: 'text-yellow-400', label: 'Clics Totales', key: 'totalClicks' },
      { icon: 'ri-scroll-to-bottom-line', color: 'text-cyan-400', label: 'Scroll Máximo', key: 'scrollDepth' },
      { icon: 'ri-hand-coin-line', color: 'text-orange-400', label: 'Interacciones', key: 'interactions' },
      { icon: 'ri-pages-line', color: 'text-pink-400', label: 'Páginas Vistas', key: 'pagesVisited' },
      { icon: 'ri-links-line', color: 'text-indigo-400', label: 'Origen', key: 'referrer' }
    ]
  },
  {
    title: '🖥️ IDENTIFICACIÓN DEL EQUIPO',
    icon: 'ri-computer-line',
    color: 'text-amber-400',
    items: [
      { icon: 'ri-computer-line', color: 'text-amber-400', label: 'Equipo', key: 'deviceName' },
      { icon: 'ri-server-line', color: 'text-teal-400', label: 'Hostname', key: 'hostname' },
      { icon: 'ri-user-3-line', color: 'text-pink-400', label: 'ID Usuario', key: 'userProfile' },
      { icon: 'ri-wifi-line', color: 'text-cyan-300', label: 'IP Local', key: 'localIP' },
      { icon: 'ri-calendar-check-line', color: 'text-green-400', label: 'Fecha', key: 'currentDate' },
      { icon: 'ri-time-line', color: 'text-yellow-400', label: 'Hora', key: 'currentTime' },
      { icon: 'ri-calendar-event-line', color: 'text-orange-400', label: 'Fecha y Hora', key: 'currentDateTime' }
    ]
  },
  {
    title: '🌐 RED E IP PÚBLICA',
    icon: 'ri-global-line',
    color: 'text-cyan-400',
    items: [
      { icon: 'ri-global-line', color: 'text-cyan-400', label: 'IP Pública', key: 'ip' },
      { icon: 'ri-map-pin-line', color: 'text-red-400', label: 'Ciudad', key: 'city' },
      { icon: 'ri-flag-line', color: 'text-green-400', label: 'País', key: 'country' },
      { icon: 'ri-map-2-line', color: 'text-yellow-400', label: 'Región', key: 'region' },
      { icon: 'ri-mail-line', color: 'text-orange-400', label: 'Cód. Postal', key: 'zip' },
      { icon: 'ri-compass-3-line', color: 'text-pink-400', label: 'Coordenadas', key: 'latlon' },
      { icon: 'ri-building-line', color: 'text-blue-400', label: 'ISP', key: 'isp' },
      { icon: 'ri-building-4-line', color: 'text-purple-400', label: 'Organización', key: 'org' },
      { icon: 'ri-route-line', color: 'text-teal-400', label: 'ASN', key: 'asn' },
      { icon: 'ri-smartphone-line', color: 'text-amber-400', label: 'Móvil', key: 'mobile' },
      { icon: 'ri-shield-line', color: 'text-red-400', label: 'Proxy/VPN', key: 'proxy' },
      { icon: 'ri-cloud-line', color: 'text-gray-400', label: 'Hosting', key: 'hosting' }
    ]
  },
  {
    title: '📱 SISTEMA Y NAVEGADOR',
    icon: 'ri-window-line',
    color: 'text-blue-400',
    items: [
      { icon: 'ri-window-line', color: 'text-blue-400', label: 'Sistema Op.', key: 'os' },
      { icon: 'ri-chrome-line', color: 'text-green-400', label: 'Navegador', key: 'browser' },
      { icon: 'ri-cpu-line', color: 'text-yellow-400', label: 'Plataforma', key: 'platform' },
      { icon: 'ri-cpu-line', color: 'text-orange-400', label: 'Núcleos CPU', key: 'cores' },
      { icon: 'ri-ram-line', color: 'text-pink-400', label: 'Memoria RAM', key: 'memory' },
      { icon: 'ri-hand-coin-line', color: 'text-cyan-400', label: 'Táctil', key: 'touch' },
      { icon: 'ri-translate-2', color: 'text-purple-400', label: 'Idioma', key: 'language' },
      { icon: 'ri-translate', color: 'text-teal-400', label: 'Idiomas', key: 'languages' },
      { icon: 'ri-time-line', color: 'text-amber-400', label: 'Zona Horaria', key: 'timezone' },
      { icon: 'ri-time-line', color: 'text-red-400', label: 'Offset UTC', key: 'timezoneOffset' },
      { icon: 'ri-history-line', color: 'text-gray-400', label: 'Historial Nav.', key: 'historyLength' },
      { icon: 'ri-file-text-line', color: 'text-indigo-400', label: 'Charset', key: 'documentCharset' }
    ]
  },
  {
    title: '💻 PANTALLA Y DISPLAY',
    icon: 'ri-monitor-line',
    color: 'text-pink-400',
    items: [
      { icon: 'ri-monitor-line', color: 'text-pink-400', label: 'Resolución', key: 'screen' },
      { icon: 'ri-aspect-ratio-line', color: 'text-cyan-400', label: 'Disponible', key: 'availScreen' },
      { icon: 'ri-layout-line', color: 'text-green-400', label: 'Viewport', key: 'viewport' },
      { icon: 'ri-window-line', color: 'text-blue-400', label: 'Ventana Ext.', key: 'outerWindow' },
      { icon: 'ri-palette-line', color: 'text-yellow-400', label: 'Prof. Color', key: 'colorDepth' },
      { icon: 'ri-palette-line', color: 'text-orange-400', label: 'Prof. Píxel', key: 'pixelDepth' },
      { icon: 'ri-zoom-in-line', color: 'text-purple-400', label: 'Pixel Ratio', key: 'dpr' },
      { icon: 'ri-rotate-lock-line', color: 'text-teal-400', label: 'Orientación', key: 'orientation' }
    ]
  },
  {
    title: '🔗 CONECTIVIDAD',
    icon: 'ri-wifi-line',
    color: 'text-green-400',
    items: [
      { icon: 'ri-wifi-line', color: 'text-green-400', label: 'Estado', key: 'online' },
      { icon: 'ri-speed-line', color: 'text-cyan-400', label: 'Tipo Conexión', key: 'connection' },
      { icon: 'ri-download-line', color: 'text-yellow-400', label: 'Velocidad', key: 'downlink' },
      { icon: 'ri-timer-line', color: 'text-orange-400', label: 'Latencia', key: 'rtt' },
      { icon: 'ri-save-line', color: 'text-pink-400', label: 'Ahorro Datos', key: 'saveData' },
      { icon: 'ri-router-line', color: 'text-purple-400', label: 'Tipo Físico', key: 'connectionType' },
      { icon: 'ri-speed-up-line', color: 'text-teal-400', label: 'Max Downlink', key: 'downlinkMax' }
    ]
  },
  {
    title: '🔍 FINGERPRINTING',
    icon: 'ri-fingerprint-line',
    color: 'text-red-400',
    items: [
      { icon: 'ri-image-line', color: 'text-red-400', label: 'Canvas FP', key: 'canvasFingerprint' },
      { icon: 'ri-volume-up-line', color: 'text-orange-400', label: 'Audio FP', key: 'audioFingerprint' },
      { icon: 'ri-3d-cude-sphere-line', color: 'text-cyan-400', label: 'GPU Vendor', key: 'webglVendor' },
      { icon: 'ri-3d-cude-sphere-line', color: 'text-green-400', label: 'GPU Renderer', key: 'webglRenderer' },
      { icon: 'ri-code-line', color: 'text-yellow-400', label: 'WebGL Ver.', key: 'webglVersion' },
      { icon: 'ri-code-s-slash-line', color: 'text-pink-400', label: 'Shading Lang', key: 'webglShadingLang' },
      { icon: 'ri-image-2-line', color: 'text-purple-400', label: 'Max Texture', key: 'webglMaxTexture' },
      { icon: 'ri-fullscreen-line', color: 'text-teal-400', label: 'Max Viewport', key: 'webglMaxViewport' },
      { icon: 'ri-puzzle-line', color: 'text-amber-400', label: 'Extensiones GL', key: 'webglExtensions' },
      { icon: 'ri-zoom-in-line', color: 'text-blue-400', label: 'Max Anisotropy', key: 'webglMaxAnisotropy' },
      { icon: 'ri-image-line', color: 'text-red-300', label: 'Max Renderbuf', key: 'webglMaxRenderbuffer' },
      { icon: 'ri-plug-line', color: 'text-indigo-400', label: 'Plugins', key: 'plugins' },
      { icon: 'ri-font-size', color: 'text-gray-400', label: 'Fuentes', key: 'fonts' }
    ]
  },
  {
    title: '🔐 SEGURIDAD Y PRIVACIDAD',
    icon: 'ri-shield-check-line',
    color: 'text-emerald-400',
    items: [
      { icon: 'ri-lock-line', color: 'text-emerald-400', label: 'Protocolo', key: 'sec_protocol' },
      { icon: 'ri-shield-check-line', color: 'text-green-400', label: 'Contexto Seguro', key: 'sec_secureContext' },
      { icon: 'ri-share-forward-line', color: 'text-cyan-400', label: 'Cross-Origin', key: 'sec_crossOriginIsolated' },
      { icon: 'ri-cookie-line', color: 'text-yellow-400', label: 'Cookies', key: 'sec_cookieEnabled' },
      { icon: 'ri-eye-off-line', color: 'text-orange-400', label: 'Do Not Track', key: 'sec_doNotTrack' },
      { icon: 'ri-key-line', color: 'text-pink-400', label: 'Permisos', key: 'sec_permissionsDetected' },
      { icon: 'ri-link-line', color: 'text-purple-400', label: 'Referrer', key: 'sec_referrerPolicy' },
      { icon: 'ri-file-pdf-line', color: 'text-teal-400', label: 'PDF Viewer', key: 'sec_pdfViewer' },
      { icon: 'ri-shield-line', color: 'text-amber-400', label: 'CSP', key: 'sec_csp' },
      { icon: 'ri-layout-masonry-line', color: 'text-red-400', label: 'Frame Status', key: 'sec_frameAncestors' }
    ]
  },
  {
    title: '⚡ RENDIMIENTO',
    icon: 'ri-speed-line',
    color: 'text-yellow-400',
    items: [
      { icon: 'ri-timer-line', color: 'text-yellow-400', label: 'Carga Página', key: 'perf_pageLoadTime' },
      { icon: 'ri-code-line', color: 'text-green-400', label: 'DOM Ready', key: 'perf_domReady' },
      { icon: 'ri-global-line', color: 'text-cyan-400', label: 'DNS Lookup', key: 'perf_dnsLookup' },
      { icon: 'ri-link-line', color: 'text-orange-400', label: 'TCP Connect', key: 'perf_tcpConnect' },
      { icon: 'ri-server-line', color: 'text-pink-400', label: 'TTFB', key: 'perf_ttfb' },
      { icon: 'ri-code-s-slash-line', color: 'text-purple-400', label: 'DOM Interactive', key: 'perf_domInteractive' },
      { icon: 'ri-ram-line', color: 'text-teal-400', label: 'JS Heap', key: 'perf_jsHeapSize' },
      { icon: 'ri-ram-line', color: 'text-amber-400', label: 'Total Heap', key: 'perf_totalHeap' },
      { icon: 'ri-file-list-line', color: 'text-blue-400', label: 'Recursos', key: 'perf_resourceCount' },
      { icon: 'ri-navigation-line', color: 'text-red-400', label: 'Tipo Nav.', key: 'perf_navigationType' },
      { icon: 'ri-refresh-line', color: 'text-gray-400', label: 'Redirects', key: 'perf_redirectCount' },
      { icon: 'ri-download-line', color: 'text-indigo-400', label: 'Transferido', key: 'perf_transferSize' },
      { icon: 'ri-lock-line', color: 'text-emerald-400', label: 'SSL Time', key: 'perf_sslTime' },
      { icon: 'ri-paint-line', color: 'text-pink-300', label: 'First Paint', key: 'perf_firstPaint' },
      { icon: 'ri-paint-brush-line', color: 'text-cyan-300', label: 'FCP', key: 'perf_fcp' }
    ]
  },
  {
    title: '📦 ALMACENAMIENTO',
    icon: 'ri-hard-drive-line',
    color: 'text-teal-400',
    items: [
      { icon: 'ri-hard-drive-line', color: 'text-teal-400', label: 'Usado', key: 'storageUsed' },
      { icon: 'ri-database-line', color: 'text-blue-400', label: 'Cuota', key: 'storageQuota' },
      { icon: 'ri-pie-chart-line', color: 'text-yellow-400', label: 'Porcentaje', key: 'storagePercent' },
      { icon: 'ri-save-line', color: 'text-green-400', label: 'LocalStorage', key: 'localStorage' },
      { icon: 'ri-save-2-line', color: 'text-orange-400', label: 'SessionStorage', key: 'sessionStorage' },
      { icon: 'ri-database-2-line', color: 'text-pink-400', label: 'IndexedDB', key: 'indexedDB' }
    ]
  },
  {
    title: '♿ ACCESIBILIDAD Y PREFERENCIAS',
    icon: 'ri-eye-line',
    color: 'text-indigo-400',
    items: [
      { icon: 'ri-speed-line', color: 'text-indigo-400', label: 'Mov. Reducido', key: 'a11y_prefersReducedMotion' },
      { icon: 'ri-moon-line', color: 'text-blue-400', label: 'Esquema Color', key: 'a11y_prefersColorScheme' },
      { icon: 'ri-contrast-line', color: 'text-yellow-400', label: 'Contraste', key: 'a11y_prefersContrast' },
      { icon: 'ri-palette-line', color: 'text-orange-400', label: 'Colores Forzados', key: 'a11y_forcedColors' },
      { icon: 'ri-invert-colors-line', color: 'text-pink-400', label: 'Invertidos', key: 'a11y_invertedColors' },
      { icon: 'ri-eye-line', color: 'text-teal-400', label: 'Transparencia', key: 'a11y_prefersTransparency' }
    ]
  },
  {
    title: '🎬 CODECS MULTIMEDIA',
    icon: 'ri-film-line',
    color: 'text-orange-400',
    items: [
      { icon: 'ri-video-line', color: 'text-orange-400', label: 'H.264', key: 'codec_h264' },
      { icon: 'ri-video-line', color: 'text-red-400', label: 'H.265', key: 'codec_h265' },
      { icon: 'ri-video-line', color: 'text-green-400', label: 'VP8', key: 'codec_vp8' },
      { icon: 'ri-video-line', color: 'text-cyan-400', label: 'VP9', key: 'codec_vp9' },
      { icon: 'ri-video-line', color: 'text-yellow-400', label: 'AV1', key: 'codec_av1' },
      { icon: 'ri-video-line', color: 'text-pink-400', label: 'WebM', key: 'codec_webm' },
      { icon: 'ri-music-line', color: 'text-purple-400', label: 'MP3', key: 'codec_mp3' },
      { icon: 'ri-music-line', color: 'text-teal-400', label: 'AAC', key: 'codec_aac' },
      { icon: 'ri-music-line', color: 'text-amber-400', label: 'OGG', key: 'codec_ogg' },
      { icon: 'ri-music-line', color: 'text-blue-400', label: 'Opus', key: 'codec_opus' },
      { icon: 'ri-music-line', color: 'text-indigo-400', label: 'FLAC', key: 'codec_flac' },
      { icon: 'ri-music-line', color: 'text-gray-400', label: 'WAV', key: 'codec_wav' },
      { icon: 'ri-image-line', color: 'text-emerald-400', label: 'WebP', key: 'codec_webp' }
    ]
  },
  {
    title: '🧩 APIs AVANZADAS',
    icon: 'ri-code-box-line',
    color: 'text-purple-400',
    items: [
      { icon: 'ri-mic-line', color: 'text-purple-400', label: 'Speech Recog.', key: 'api_speechRecognition' },
      { icon: 'ri-speak-line', color: 'text-blue-400', label: 'Speech Synth.', key: 'api_speechSynthesis' },
      { icon: 'ri-gamepad-line', color: 'text-green-400', label: 'Gamepad', key: 'api_gamepad' },
      { icon: 'ri-vibrate-line', color: 'text-yellow-400', label: 'Vibración', key: 'api_vibration' },
      { icon: 'ri-moon-line', color: 'text-orange-400', label: 'Wake Lock', key: 'api_wakeLock' },
      { icon: 'ri-share-line', color: 'text-pink-400', label: 'Web Share', key: 'api_share' },
      { icon: 'ri-clipboard-line', color: 'text-cyan-400', label: 'Clipboard', key: 'api_clipboard' },
      { icon: 'ri-key-line', color: 'text-teal-400', label: 'Credentials', key: 'api_credentials' },
      { icon: 'ri-tv-line', color: 'text-amber-400', label: 'Presentation', key: 'api_presentation' },
      { icon: 'ri-usb-line', color: 'text-red-400', label: 'Serial', key: 'api_serial' },
      { icon: 'ri-keyboard-line', color: 'text-indigo-400', label: 'HID', key: 'api_hid' },
      { icon: 'ri-nfc-line', color: 'text-gray-400', label: 'NFC', key: 'api_nfc' },
      { icon: 'ri-vr-line', color: 'text-emerald-400', label: 'WebXR', key: 'api_xr' },
      { icon: 'ri-music-2-line', color: 'text-pink-300', label: 'MIDI', key: 'api_midi' },
      { icon: 'ri-bluetooth-line', color: 'text-blue-300', label: 'Bluetooth', key: 'api_bluetooth' },
      { icon: 'ri-usb-line', color: 'text-green-300', label: 'USB', key: 'api_usb' },
      { icon: 'ri-play-circle-line', color: 'text-yellow-300', label: 'Media Session', key: 'api_mediaSession' },
      { icon: 'ri-lock-2-line', color: 'text-orange-300', label: 'Web Locks', key: 'api_locks' },
      { icon: 'ri-contacts-line', color: 'text-cyan-300', label: 'Contacts', key: 'api_contactPicker' },
      { icon: 'ri-eyedropper-line', color: 'text-purple-300', label: 'EyeDropper', key: 'api_eyeDropper' },
      { icon: 'ri-folder-open-line', color: 'text-teal-300', label: 'File System', key: 'api_fileSystem' },
      { icon: 'ri-barcode-line', color: 'text-amber-300', label: 'Barcode', key: 'api_barcode' },
      { icon: 'ri-user-smile-line', color: 'text-red-300', label: 'Face Detect', key: 'api_faceDetection' },
      { icon: 'ri-text-line', color: 'text-indigo-300', label: 'Text Detect', key: 'api_textDetection' },
      { icon: 'ri-rest-time-line', color: 'text-gray-300', label: 'Idle Detect', key: 'api_idleDetection' },
      { icon: 'ri-screenshot-line', color: 'text-emerald-300', label: 'Screen Capture', key: 'api_screenCapture' },
      { icon: 'ri-picture-in-picture-line', color: 'text-pink-200', label: 'PiP', key: 'api_pictureInPicture' },
      { icon: 'ri-send-plane-line', color: 'text-blue-200', label: 'WebTransport', key: 'api_webTransport' },
      { icon: 'ri-video-add-line', color: 'text-green-200', label: 'WebCodecs', key: 'api_webCodecs' }
    ]
  },
  {
    title: '🔧 CAPACIDADES DEL NAVEGADOR',
    icon: 'ri-settings-line',
    color: 'text-gray-400',
    items: [
      { icon: 'ri-tools-line', color: 'text-gray-400', label: 'Web Workers', key: 'webWorkers' },
      { icon: 'ri-service-line', color: 'text-blue-400', label: 'Service Worker', key: 'serviceWorker' },
      { icon: 'ri-3d-cude-sphere-line', color: 'text-green-400', label: 'WebGL', key: 'webGL' },
      { icon: 'ri-3d-cude-sphere-line', color: 'text-cyan-400', label: 'WebGL 2', key: 'webGL2' },
      { icon: 'ri-video-chat-line', color: 'text-yellow-400', label: 'WebRTC', key: 'webRTC' },
      { icon: 'ri-code-line', color: 'text-orange-400', label: 'WebAssembly', key: 'webAssembly' },
      { icon: 'ri-group-line', color: 'text-pink-400', label: 'SharedWorker', key: 'sharedWorker' },
      { icon: 'ri-link-line', color: 'text-purple-400', label: 'WebSocket', key: 'webSocket' },
      { icon: 'ri-magic-line', color: 'text-teal-400', label: 'Web Animation', key: 'webAnimation' },
      { icon: 'ri-eye-line', color: 'text-amber-400', label: 'IntersectObs', key: 'intersectionObserver' },
      { icon: 'ri-fullscreen-line', color: 'text-red-400', label: 'ResizeObs', key: 'resizeObserver' },
      { icon: 'ri-code-s-slash-line', color: 'text-indigo-400', label: 'MutationObs', key: 'mutationObserver' },
      { icon: 'ri-broadcast-line', color: 'text-emerald-400', label: 'BroadcastCh', key: 'broadcastChannel' },
      { icon: 'ri-map-pin-line', color: 'text-cyan-300', label: 'Geolocalización', key: 'geolocation' },
      { icon: 'ri-notification-line', color: 'text-yellow-300', label: 'Notificaciones', key: 'notifications' }
    ]
  },
  {
    title: '🔋 BATERÍA',
    icon: 'ri-battery-line',
    color: 'text-green-400',
    items: [
      { icon: 'ri-battery-charge-line', color: 'text-green-400', label: 'Nivel', key: 'batteryLevel' },
      { icon: 'ri-flashlight-line', color: 'text-yellow-400', label: 'Estado', key: 'batteryStatus' },
      { icon: 'ri-timer-line', color: 'text-cyan-400', label: 'T. Carga', key: 'batteryChargeTime' },
      { icon: 'ri-timer-line', color: 'text-red-400', label: 'T. Descarga', key: 'batteryDischargeTime' }
    ]
  },
  {
    title: '📤 DISPOSITIVOS MULTIMEDIA',
    icon: 'ri-webcam-line',
    color: 'text-rose-400',
    items: [
      { icon: 'ri-mic-line', color: 'text-rose-400', label: 'Micrófonos', key: 'microphones' },
      { icon: 'ri-webcam-line', color: 'text-blue-400', label: 'Cámaras', key: 'cameras' },
      { icon: 'ri-speaker-line', color: 'text-green-400', label: 'Parlantes', key: 'speakers' },
      { icon: 'ri-device-line', color: 'text-yellow-400', label: 'Total Disp.', key: 'totalDevices' }
    ]
  },
  {
    title: '📍 PÁGINA ACTUAL',
    icon: 'ri-pages-line',
    color: 'text-sky-400',
    items: [
      { icon: 'ri-link-line', color: 'text-sky-400', label: 'URL', key: 'pageURL' },
      { icon: 'ri-lock-line', color: 'text-green-400', label: 'Protocolo', key: 'pageProtocol' },
      { icon: 'ri-server-line', color: 'text-yellow-400', label: 'Host', key: 'pageHost' },
      { icon: 'ri-route-line', color: 'text-orange-400', label: 'Path', key: 'pagePath' },
      { icon: 'ri-file-text-line', color: 'text-pink-400', label: 'Título', key: 'documentTitle' }
    ]
  }
];
